import dayjs from "dayjs";
export class Utils {
    static errorMessage(response) {
        if (response == null) {
            return "Si è verificato un errore.";
        }
        if (!response.success) {
            switch (response.errorCode) {
                case 500:
                    return "Si è verificato un errore interno al server.";
                case 400:
                    return "Non è stato possibile elaborare la richiesta.";
                case 401:
                    return "Username o password errati.";
                case 403:
                    return "Non hai i permessi necessari per poter inviare la richiesta.";
                case 404:
                    return "Non trovato.";
                default:
                    return "Si è verificato un errore.";
            }
        }
    }
    static dateFromTimestamp(timeStamp) {
        if (timeStamp != null) {
            return dayjs(timeStamp).format('DD/MM/YYYY');
        }
        return null;
    }
    static formatDate(date) {
        if (date != null) {
            let split = date.split("/");
            let formatArray = split.reverse();
            return formatArray.join("-");
        }
        return date;
    }
    static returnValueOrAlternativeValue(value, alternativeValue) {
        if (typeof value === "string") {
            if (value === "") {
                return alternativeValue;
            }
        }
        if (value === null) {
            return alternativeValue;
        }
        return value;
    }
    static getFileName(path, uuid) {
        let array = path.split(uuid + "/");
        return array[1];
    }
    static translateToIt(toTranslate) {
        switch (toTranslate) {
            case "lastUpdate":
                return "Ultimo aggiornamento";
            case "client":
                return "Cliente";
            case "nasid":
                return "Nas id";
            case "since":
                return "Data d'inizio";
            case "until":
                return "Data di fine";
            case "operator":
                return "Operatore";
            case "DESC":
                return "Discendente";
            case "ASC":
                return "Ascendente";
            default:
                console.error("No string to translate to italian.");
                return null;
        }
    }
    static translateToOrigin(toTranslate) {
        switch (toTranslate) {
            case "Ultimo aggiornamento":
                return "lastUpdate";
            case "Cliente":
                return "client";
            case "Nas id":
                return "nasid";
            case "Data d'inizio":
                return "since";
            case "Data di fine":
                return "until";
            case "Operatore":
                return "operator";
            case "Discendente":
                return "DESC";
            case "Ascendente":
                return "ASC";
            default:
                console.error("No string to translate to origin.");
                return null;
        }
    }
}
